import { RootState } from "../store";

export const getAppSettings = (state: RootState) => {
    return state.appSettingsReducer.appSettings;
};
